import { render, staticRenderFns } from "./order-qualification-result.vue?vue&type=template&id=ca0db954&scoped=true"
import script from "./order-qualification-result.vue?vue&type=script&lang=js"
export * from "./order-qualification-result.vue?vue&type=script&lang=js"
import style0 from "./order-qualification-result.vue?vue&type=style&index=0&id=ca0db954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0db954",
  null
  
)

export default component.exports